import { sanitizeFilename } from 'helpers/files';

import { disableAddFileButton, getUrlParameter } from '../../attachments';

$(document).ready(() => {
  $('#pdf_file').on('change', submitForm);
  // Checking to see if a new pdf has been added to a project and jump to it
  if (getUrlParameter('pdf_id')) {
    window.location.hash = getUrlParameter('pdf_id');
  }

  function submitForm(event) {
    const allowedTypes = ['pdf'];
    const displayButton = $('.upload_button');

    const key = $('#upload_pdf input[name="key"]').val();
    const pdfFilename = sanitizeFilename(
      $(event.currentTarget).val().split('/').pop().split('\\').pop(),
    );

    const inputFile = $(event.currentTarget);
    const inputFileType = event.currentTarget.files[0].type
      .split('/')
      .pop()
      .toLowerCase();
    const inputFileSize = event.currentTarget.files[0].size;

    if (
      $.inArray(inputFileType, allowedTypes) >= 0 &&
      inputFileSize <= 10000000
    ) {
      disableAddFileButton(displayButton);
      $('#upload_pdf input[name="key"]').val(
        key.replace('${filename}', pdfFilename),
      );
      $('#upload_pdf').submit();
      fetchPendingPdf();
    } else if ($.inArray(inputFileType, allowedTypes) < 0) {
      $('.pdf-warning').modal();
      inputFile.replaceWith(inputFile.val('').clone(true));
    } else {
      $('.file-warning').modal();
      inputFile.replaceWith(inputFile.val('').clone(true));
    }

    // fetches pending pdf row
    function fetchPendingPdf() {
      const projectId =
        typeof projectId !== 'undefined' ? projectId : undefined;
      const companyId =
        typeof companyId !== 'undefined' ? companyId : undefined;

      const data = {
        pdf_filename: pdfFilename,
      };

      if (projectId) {
        $.ajax({
          url: '/projects/' + projectId.value + '/pdfs/new.js',
          type: 'GET',
          data,
        });
      } else if (companyId) {
        $.ajax({
          url: '/companies/' + companyId.value + '/pdfs/new.js',
          type: 'GET',
          data,
        });
      }
    }
  }
});
